var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompletedTick = function SvgCompletedTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M12 2.53a9.47 9.47 0 1 0 0 18.94 9.47 9.47 0 0 0 0-18.94m4.16 7.5-5.25 5.25c-.16.16-.39.26-.62.26s-.46-.09-.62-.26L7.4 13.01a.88.88 0 0 1 0-1.24c.34-.34.9-.34 1.24 0l1.65 1.65 4.63-4.63c.34-.34.9-.34 1.24 0s.34.9 0 1.24"
  })));
};
export default SvgCompletedTick;